import $ from 'jquery';

Drupal.behaviors.preventPaste = {
  attach: function (context) {
    let $inputElements = $('.no-paste');

    $inputElements.bind(
      "cut copy paste contextmenu",
      function ( e ) {
        e.preventDefault();
      }
    );
  }
};
